import {
  EmailOutlined,
  OpenInNewOutlined,
  PhoneOutlined,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Divider,
  Typography,
} from '@mui/material';
import { green } from '@mui/material/colors';

import { IIPENNotary } from '../../../types/Notary';
import { formatPartyName, phoneObjToString } from '../../utils/helpers';

interface IProps {
  notary: IIPENNotary;
  loading: boolean;
  linkDisabled: boolean;
  openLink: () => void;
}

export default function IPENSessionNotary(props: IProps) {
  const { notary, linkDisabled, loading, openLink } = props;

  return (
    <Card
      raised={!linkDisabled}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: (theme) => theme.spacing(2),
        margin: (theme) => theme.spacing(2),
        marginTop: '0px',
        borderLeft: !linkDisabled ? `10px solid ${green[500]}` : 'none',
      }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography variant='button'>
          {formatPartyName(
            {
              FirstName: notary?.FirstName,
              LastName: notary?.LastName,
              MiddleName: notary?.MiddleName,
              Suffix: notary?.Suffix,
            },
            'non-signer'
          )}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          {notary?.Email && (
            <Button
              startIcon={<EmailOutlined />}
              size='small'
              style={{ textTransform: 'none' }}>
              {notary?.Email ? notary?.Email : ''}
            </Button>
          )}
          {notary?.PhoneNumber && (
            <Button startIcon={<PhoneOutlined />} size='small'>
              {notary?.PhoneNumber ? phoneObjToString(notary?.PhoneNumber) : ''}
            </Button>
          )}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {loading ? (
          <CircularProgress size='26px' />
        ) : !linkDisabled ? (
          <>
            <Typography
              variant='button'
              sx={{ color: (theme) => theme.palette.primary.main }}>
              Attest the documents & attach the seal.
            </Typography>
            <Divider
              orientation='vertical'
              variant='middle'
              flexItem
              sx={{ my: 0, mx: 2 }}
            />
            <Button
              onClick={() => openLink()}
              endIcon={<OpenInNewOutlined />}
              variant='contained'
              sx={{ background: green[500] }}
              disableElevation>
              Review & Sign
            </Button>
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}>
            <Typography
              variant='button'
              sx={{ color: (theme) => theme.palette.primary.main }}>
              Awaiting Signatures
            </Typography>
          </Box>
        )}
      </Box>
    </Card>
  );
}
